import { Image, Spinner, useToast } from '@chakra-ui/react'
import React, { useState } from 'react'
import { SalvarImagensFinanceiro } from '../../../../services/api'
import * as S from "../styles";


const IconAnexar = "/images/anexar.svg";


const ComponentFlexInput = () => {

  const toast = useToast();

  const [formValues, setFormValues] = useState({})
  const [boleto, setBoleto] = useState('')
  const [loading, setloading] = useState(false)

  const handleInputOnChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value
    })
  }

  const enviarBoleto = async (e) => {
    e.preventDefault();
    if (!boleto && document.getElementById("input_numero_nota").value === '') {
      toast(
        {
          position: "top",
          title: "Preencha os campos",
          description: `É obrigatório preencher o campo de arquivo e numero nota`,
          status: "error",
          duration: 3000,
          isClosable: true,
        },
      );
    } else if (!boleto) {
      toast(
        {
          position: "top",
          title: "Preencha os campos",
          description: `É obrigatório preencher o campo do arquivo`,
          status: "error",
          duration: 3000,
          isClosable: true,
        },
      );
    } else if (document.getElementById("input_numero_nota").value === '') {
      toast(
        {
          position: "top",
          title: "Preencha os campos",
          description: `É obrigatório preencher o campo numero nota`,
          status: "error",
          duration: 3000,
          isClosable: true,
        },
      );

    } else {
      setloading(true)
      try {
        const formData = new FormData();
        formData.append('arquivo', document.getElementById("arquivo").files[0]);
        formData.append('numero_nota', formValues.numero_nota);
        formData.append('name', `boleto-${formValues.numero_nota}`);

        const response = await SalvarImagensFinanceiro.post('', formData)
        const dataresponse = response.data;

        setloading(false)
        toast(
          {
            position: "top",
            title: "Enviado com sucesso",
            description: `arquivo ${boleto.name.slice(0, -4)} e numero nota ${formValues.numero_nota}!`,
            status: "success",
            duration: 4000,
            isClosable: true,
          },
        );
        setBoleto('')
        setFormValues({ numero_nota: '' })
        document.getElementById('arquivo').value = ''
        document.getElementById('input_numero_nota').value = ''

      } catch (error) {
        toast(
          {
            position: "top",
            title: "Nº nota inexistente!",
            description: `Nº de nota '${formValues.numero_nota}' não existe.`,
            status: "error",
            duration: 3000,
            isClosable: true,
          },
        );
        setFormValues({ numero_nota: '' })
        document.getElementById('arquivo').value = ''
        document.getElementById('input_numero_nota').value = ''
        console.log(Object.keys(error), error.message);
        setloading(false)
      }
    }
  }


  return (
    <form onSubmit={enviarBoleto}>
      <S.FlexInput>
        <S.InputNNota fontSize='16px' name='numero_nota' fontFamily='Arial' id='input_numero_nota' onChange={handleInputOnChange} h='35px' w='300px' type='number' focusBorderColor='#378BBF' borderColor='#378BBF' _placeholder={{ color: '#378BBF', fontFamily: 'Arial', textAlign: 'left' }} placeholder='Nº da nota' />
        <S.InputFile id="selectFile">
          <Image src={IconAnexar} position='relative' alt='icon_input' w='auto' h='30px' top='2px' left='15px' zIndex={20} />
          <label id='label_pdf'>ANEXAR PDF</label>
          <input accept="application/pdf,application/vnd.ms-excel" onChange={e => setBoleto(e.target.files[0])} type="file" id='arquivo' name="file" />
        </S.InputFile>
        <S.ButtonEviar id='button_enviar' type='submit' as='button'>
          {loading ? (
            <Spinner mt='3px' />
          ) : (
            <span class="noselect">SALVAR</span>
          )}
        </S.ButtonEviar>
      </S.FlexInput>
    </form>
  )
}

export default ComponentFlexInput